import { render, staticRenderFns } from "./TransactionsItem.vue?vue&type=template&id=72d115eb&"
import script from "./TransactionsItem.vue?vue&type=script&lang=js&"
export * from "./TransactionsItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports